/* eslint-disable jsx-a11y/label-has-associated-control */
/**
 * Renders a CustomerDetailView.
 * @returns {JSX.Element} Rendered component
 */

import LocalStorage from 'Helpers/MFXLocalStorage';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ModalOverlay from '../Common/ModalOverlay';
import Loading from '../Elements/Loading';
import QrScanner from '../Elements/QrScanner';
import SavedModal from '../Elements/SavedModal';
import apiPost from '../Hooks/apiPost';
import GenericElement from '../Utils/GenericElement';
import loadJsonData from '../Utils/loadJsonData';
import URLS from '../Utils/URLs.API';
import { getDurationInMinutesABS, getTodaysDate } from '../../../Helpers/dateHelper';
import store, { detailViewActions } from '../../../Helpers/Stores/detailViewStoreCRM';
import { Provider } from 'react-redux';
import { mainTabLink } from '../Utils/sessionedLinks';
import loadJsonPut from '../Utils/jsonPut';
import ConfirmPopup from '../Elements/ConfirmPopup';

function AddView(props: any): JSX.Element {
    //const viewData = useSelector((state: RootState) => state.viewData);
    const [viewData, setViewData] = useState(null as any);

    const [searchParams, setSearchParams] = useSearchParams();
    const type = searchParams.get('type');
    const index = searchParams.get('index');
    const customer = searchParams.get('customer');
    const process = props.withoutProcess ? null : searchParams.get('process');

    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchResultLoaded, setSearchResultLoaded] = useState(true);
    const [saveMessage, setSaveMessage] = useState(null as any);
    const [curCustomer, setCustomer] = useState<null | any>(null);
    const [curProcess, setCurProcess] = useState<null | any>(null);
    const [searchResults, setSearchResults] = useState<null | any>(null);
    const [addForm, setAddForm] = useState<null | any>(null);
    const [recording, setRecording] = useState(false);
    const [downloadICL, setDownloadICL] = useState(false);
    const [closeOriginalTask, setCloseOriginalTask] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [profilingLoaded, setProfilingLoaded] = useState(false);
    const [filledData, setFilledData] = useState(props?.viewData?.Data);
    const [forwardingLink, setForwardingLink] = useState(null as any);
    const [pendingData, setPendingData] = useState(null);

    const [qrCode, setQrCode] = useState({
        active: false,
        qrcodedata: {},
        hasVideo: 'mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices ? true : false,
    });
    let timeout: null | ReturnType<typeof setTimeout> = null;
    useEffect(() => {
        loadCustomer();
        setProfilingLoaded(false);
        loadForm();
        if (process) loadProcess();
    }, []);
    function loadProcess() {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetProcess + process).then((data: any) => {
            if (data.Data !== null) {
                setCurProcess(data.Data);
            }
        });
    }
    function loadCustomer() {
        if (customer && !props.viewSettings.selectCustomer) {
            setCustomer({ id: customer });
        } else if (props.viewSettings.customer) {
            setCustomer(props.viewSettings.customer);
            props.viewSettings.fixCustomer = true;
        } else if (props.viewSettings.needCustomer) {
            const currentPath = LocalStorage.getCurrentPath();
            if (currentPath && currentPath.indexOf('CUSTOMER') > 0) {
                let tabCustomer = LocalStorage.getTabData();
                setCustomer({ id: tabCustomer?.primaryId, name: tabCustomer?.context.customerName });
                props.viewSettings.fixCustomer = true;
            }
        }
    }

    function genObject(obj, keys, val) {
        if (keys.length === 1) {
            obj[keys[0]] = val;
            return obj;
        }
        obj[keys[0]] = genObject(obj[keys[0]] ?? {}, keys.slice(1), val);
        return obj;
    }

    function loadForm() {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.ViewLayouts + '?ViewName=' + props.viewName + '&LayoutName=' + (props.layoutName ?? 'default'))
            .then((data: any) => {
                if (data.Data !== null) {
                    setAddForm(data.Data.Json);
                    let emptyObject = {} as any;
                    if (data.Data.Json.ElementsOrder) {
                        // OLD 17.01.24
                        data.Data.Json.ElementsOrder[0].forEach(key => {
                            const keys = (key as string).split('-');
                            if (keys[0] === 'Data') keys.splice(0, 1);
                            emptyObject = genObject(emptyObject, keys, data.Data.Json.DesignElements[key]?.DefaultValue ? data.Data.Json.DesignElements[key]?.DefaultValue : data.Data.Json.DesignElements[key]?.Elementtype === 'checkbox' ? false : '');
                            //emptyObject[key] = data.Data.Json.DesignElements[key].Elementtype === 'checkbox' ? false : '';
                            /*------------ SPECIAL CONDITIONS --------------*/

                            if (key === 'Begin') emptyObject[key] = getTodaysDate(0, 'datetime-local');
                            else if (key === 'EndTime') emptyObject[key] = getTodaysDate(2, 'datetime-local');

                            /*------------ ADD DEFAULT VALUES!!!! --------------*/
                        });
                    } else {
                        Object.entries(data.Data.Json.DesignElements).forEach((el: any) => {
                            const keys = (el[1].Key as string).split('-');
                            emptyObject = genObject(emptyObject, keys, el[1].DefaultValue ? el[1].DefaultValue : el[1]?.Elementtype === 'checkbox' ? false : '');
                            if (el[1].Key === 'Begin') emptyObject[el[1].Key] = getTodaysDate(0, 'datetime-local');
                            else if (el[1].Key === 'EndTime') emptyObject[el[1].Key] = getTodaysDate(2, 'datetime-local');
                        });
                    }

                    /*------------ PROCESS AUS TASK --------------*/
                    if (props.withFilledData) {
                        emptyObject = JSON.parse(JSON.stringify(props.viewData.Data));
                        if (props.viewName === 'NoteAddView') {
                            // just to stop the error
                        } else {
                            emptyObject.Process.Text = props.viewData.Data.ProcessingText;
                            emptyObject.ProcessingText = '';
                            emptyObject.TaskText = 'Vorgang: ' + props.viewData.Data.Process.Number + ' Aufgaben Pos.: ' + props.viewData.Data.PositionNumber;
                            emptyObject.Process.Number = null;
                            emptyObject.Process.Index = null;
                            emptyObject.PositionNumber = null;
                            emptyObject.Begin = getTodaysDate(0, 'datetime-local');
                            emptyObject.EndTime = getTodaysDate(2, 'datetime-local');
                            emptyObject.Index = null;
                            emptyObject = Object.fromEntries(Object.entries(emptyObject).filter(([_, v]) => v != null));
                            emptyObject.Process = Object.fromEntries(Object.entries(emptyObject.Process).filter(([_, v]) => v != null));
                        }
                    }
                    if (emptyObject.PersonInChargeName === '' || emptyObject.PersonInChargeID === '') {
                        emptyObject.PersonInChargeName = LocalStorage.getData('UserData').CRMPersonInCharge;
                        emptyObject.PersonInChargeID = LocalStorage.getData('UserData').Index;
                    }
                    if (props.viewSettings.addView === 'LeadAddView') {
                        emptyObject.Assignment = 'LEAD';
                    }
                    if (emptyObject.PersonInChargeNumber === '') {
                        emptyObject.PersonInChargeNumber = LocalStorage.getData('UserData').Number;
                    }
                    if (props.viewSettings.addView === 'ProjectAddView' && !emptyObject.ProjectTypeInx) {
                        emptyObject.ProjectTypeInx = 0;
                    }
                    if (props.viewSettings.addView === 'TimeRecordingAddView') {
                        emptyObject.Type = 'N-1';
                    }
                    if (props.viewSettings.addView === 'ProjectAddView' && !emptyObject.ProjectStatusSystemInx) {
                        emptyObject.ProjectStatusSystemInx = 1;
                    }
                    if (props.viewSettings.addView === 'ProjectAddView' && !emptyObject.ProjectStatusInx) {
                        emptyObject.ProjectStatusInx = 1;
                    }
                    if (props.viewSettings.addView === 'CustomerVisitAddView') {
                        emptyObject.Process.Assignment = 'VISIT';
                    }
                    if (props.layoutName === 'AddTaskToLead') {
                        if (!emptyObject.Process) emptyObject.Process = {};
                        emptyObject.Process.Index = index;
                    }
                    setViewData({ Data: emptyObject, DesignElements: data.Data.Json.DesignElements });
                    setDataLoaded(true);
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    const handleSubmitIntermidia = e => {
        e.preventDefault();

        const data = e.target;
        console.log(props);
        console.log(data);
        if (props.viewName === 'TimeRecordingAddView') {
            const dayMap = ['WorkingTimeSunday', 'WorkingTimeMonday', 'WorkingTimeTuesday', 'WorkingTimeWednesday', 'WorkingTimeThursday', 'WorkingTimeFriday', 'WorkingTimeSaturday'];
            console.log(viewData.Data);

            const dayKey = dayMap[new Date(viewData.Data.Date)?.getDay()];
            const time = JSON.parse(localStorage.getItem('UserData') as any)?.[dayKey];
            if (time === '00:00:00') {
                setPendingData(data);
                setConfirmOpen(true);
                return;
            }
        }

        handleSubmit(e);
    };

    async function handleSubmit(e: any) {
        setDataLoaded(false);
        let curFormData = e.target;
        let validate = 0;

        /* ----------------- VALIDATION ------------------- */

        for (let i = 0; i < curFormData.length; i++) {
            if (curFormData.elements[i].Required && !curFormData.elements[i].value) {
                curFormData.elements[i].classList.add('required-error');
                validate++;
            }
        }

        //clear errors
        document.querySelector('required-error')?.classList.remove('required-error');
        let requiredContainer = document.getElementsByClassName('required-true');
        for (let j = 0; j < requiredContainer.length; j++) {
            let input = (requiredContainer[j] as HTMLElement).querySelectorAll('input')[1];
            if (input && !input.value) {
                let nameOfAlternative = viewData.DesignElements[input.name].Conditions && viewData.DesignElements[input.name].Conditions[0] ? viewData.DesignElements[input.name].Conditions[0].value : null;
                if (nameOfAlternative && (typeof viewData.Data[nameOfAlternative] === 'object' ? viewData.Data[nameOfAlternative]?.value : viewData.Data[nameOfAlternative])) {
                    //make a loop if more than 1 condition
                } else {
                    (requiredContainer[j] as HTMLElement).querySelector('div[class*=-control]')?.classList.add('required-error');
                    validate++;
                }
            }
        }

        if (validate > 0) {
            setDataLoaded(true);
        } else {
            const newData = {} as any;
            newData.CreateData = {} as any;
            switch (props.viewSettings.addView) {
                case 'LeadAddView':
                case 'NoteAddView':
                    newData.CreateData = { ...viewData.Data };
                    if (props.viewSettings.needCustomer) {
                        newData.CreateData.CustomerSupplierNumber = customer ?? curCustomer?.id;
                        newData.CreateData.ContactPersonData.CustomerNumber = customer ?? curCustomer?.id;
                    }
                    if (newData.CreateData.ProfilingValues) {
                        newData.CreateData.ProfilingValues = newData.CreateData.ProfilingValues.map(profiling => {
                            return { ...profiling, Index: 0, ProcessIndex: 0 };
                        });
                    }
                    break;
                case 'ProjectAddView':
                    newData.CreateData = { ...viewData.Data };
                    if (!viewData.Data.ProjectTypeInx) {
                        newData.CreateData.ProjectTypeInx = 0;
                    }
                    if (!viewData.Data.ProjectStatusSystemInx) {
                        newData.CreateData.ProjectStatusSystemInx = 1;
                    }
                    if (!viewData.Data.ProjectStatusInx) {
                        newData.CreateData.ProjectStatusInx = 1;
                    }
                    if (newData.CreateData.ProjectCustomer) newData.CreateData.ProjectCustomer.CustomerNumber = customer ?? curCustomer?.id;
                    else newData.CreateData.ProjectCustomer = { CustomerNumber: customer ?? curCustomer?.id };
                    break;
                case 'ContactPersonAddView':
                    newData.CreateData = { ...viewData.Data };
                    newData.CreateData.CustomerNumber = customer ?? curCustomer?.id;
                    break;
                case 'TimeRecordingAddView':
                    /*newData.Data = { TimeRecordingEntriesData: [{ ...viewData.Data }] };

                    newData.Data.TimeRecordingEntriesData[0].CustomWorkingType = newData.Data.TimeRecordingEntriesData[0].Type?.split('-')[0] || 'N';
                    newData.Data.TimeRecordingEntriesData[0].WorkingType = newData.Data.TimeRecordingEntriesData[0].Type?.split('-')[1] || 1;
                    newData.Data.TimeRecordingEntriesData[0].Duration = getDurationInMinutesABS(newData.Data.TimeRecordingEntriesData[0].WorkingTimeFrom, newData.Data.TimeRecordingEntriesData[0].WorkingTimeUntil);
                    if (!newData.Data.TimeRecordingEntriesData[0].Text) {
                        newData.Data.TimeRecordingEntriesData[0].Text = '';
                    }
                    if (newData.Data.TimeRecordingEntriesData[0].WorkingTimeUntil && newData.Data.TimeRecordingEntriesData[0].WorkingTimeFrom) {
                        let from = new Date(newData.Data.TimeRecordingEntriesData[0].WorkingTimeFrom);
                        let until = new Date(newData.Data.TimeRecordingEntriesData[0].WorkingTimeUntil);
                        from.setMilliseconds(0);
                        until.setMilliseconds(0);
                        if (from > until) {
                            console.log('Arrival > Departure');
                            setDataLoaded(true);
                            return;
                        }
                    }*/
                    var entries = [] as any;
                    var originalEntry = { ...viewData.Data };

                    if (originalEntry.DateUntil) {
                        let startDate = new Date(originalEntry.Date);
                        let endDate = new Date(originalEntry.DateUntil);

                        // Ensure milliseconds are 0 for accurate comparison
                        startDate.setMilliseconds(0);
                        endDate.setMilliseconds(0);

                        const dayMap = ['WorkingTimeSunday', 'WorkingTimeMonday', 'WorkingTimeTuesday', 'WorkingTimeWednesday', 'WorkingTimeThursday', 'WorkingTimeFriday', 'WorkingTimeSaturday'];
                        const userData = JSON.parse(localStorage.getItem('UserData') as any) || {};

                        while (startDate <= endDate) {
                            const dayKey = dayMap[startDate.getDay()];
                            const time = userData[dayKey];

                            // Skip this date if working time = "00:00:00"
                            if (time === '00:00:00') {
                                startDate.setDate(startDate.getDate() + 1);
                                continue;
                            }

                            const entry = { ...originalEntry };

                            const duration = getDurationInMinutesABS(entry.WorkingTimeFrom, entry.WorkingTimeUntil);
                            entry.Duration = duration;
                            entry.Date = new Date(startDate);

                            entry.CustomWorkingType = entry.Type?.split('-')[0] || 'N';
                            entry.WorkingType = entry.Type?.split('-')[1] || 1;
                            entry.Text = entry.Text || '';
                            if (entry.WorkingType === '80') entry.Duration = 1;

                            const from = new Date(startDate);
                            const until = new Date(startDate);
                            until.setHours(new Date(entry.WorkingTimeUntil).getHours());
                            until.setMinutes(new Date(entry.WorkingTimeUntil).getMinutes());
                            from.setHours(new Date(entry.WorkingTimeFrom).getHours());
                            from.setMinutes(new Date(entry.WorkingTimeFrom).getMinutes());
                            entry.WorkingTimeFrom = from.toISOString();
                            entry.WorkingTimeUntil = until.toISOString();
                            entries.push(entry);

                            startDate.setDate(startDate.getDate() + 1);
                        }
                    } else {
                        const entry = { ...originalEntry };
                        entry.CustomWorkingType = entry.Type?.split('-')[0] || 'N';
                        entry.WorkingType = entry.Type?.split('-')[1] || 1;
                        let currentDate = new Date(entry.Date);
                        entry.WorkingTimeFrom.setFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                        entry.WorkingTimeUntil.setFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                        if (entry.WorkingType === '80') entry.Duration = 1;
                        else entry.Duration = getDurationInMinutesABS(entry.WorkingTimeFrom, entry.WorkingTimeUntil);
                        entry.Text = entry.Text || '';
                        entries.push(entry);
                    }

                    newData.Data = { TimeRecordingEntriesData: entries };

                    if (newData.Data.TimeRecordingEntriesData.length > 0) {
                        const first = new Date(newData.Data.TimeRecordingEntriesData[0].WorkingTimeFrom);
                        const last = new Date(newData.Data.TimeRecordingEntriesData[0].WorkingTimeUntil);
                        first.setMilliseconds(0);
                        last.setMilliseconds(0);
                        if (first > last) {
                            console.log('Arrival > Departure');
                            setDataLoaded(true);
                            return;
                        }
                    }

                    break;
                case 'ExpenseReportAddView':
                    newData.Data = { TravelExpenseData: [{ ...viewData.Data }] };
                    if (newData.Data.TravelExpenseData[0].Date) {
                        if (newData.Data.TravelExpenseData[0].Departure) {
                            var newDeparture = new Date(newData.Data.TravelExpenseData[0].Date);
                            newData.Data.TravelExpenseData[0].Departure = new Date(newData.Data.TravelExpenseData[0].Departure);
                            newDeparture.setHours(newData.Data.TravelExpenseData[0].Departure.getHours(), newData.Data.TravelExpenseData[0].Departure.getMinutes(), newData.Data.TravelExpenseData[0].Departure.getSeconds());
                            newData.Data.TravelExpenseData[0].Departure = newDeparture;
                        }
                        if (newData.Data.TravelExpenseData[0].Arrival) {
                            var newArrival = new Date(newData.Data.TravelExpenseData[0].Date);
                            newData.Data.TravelExpenseData[0].Arrival = new Date(newData.Data.TravelExpenseData[0].Arrival);
                            newArrival.setHours(newData.Data.TravelExpenseData[0].Arrival.getHours(), newData.Data.TravelExpenseData[0].Arrival.getMinutes(), newData.Data.TravelExpenseData[0].Arrival.getSeconds());
                            newData.Data.TravelExpenseData[0].Arrival = newArrival;
                        }
                        console.log(newData);
                    }
                    if (newData.Data.TravelExpenseData[0].Arrival && newData.Data.TravelExpenseData[0].Departure && newData.Data.TravelExpenseData[0].Departure > newData.Data.TravelExpenseData[0].Arrival) {
                        console.log('Arrival > Departure');
                        setDataLoaded(true);
                        return;
                    }
                    break;
                default:
                    newData.CreateData.Task = { ...viewData.Data };
                    if (!newData.CreateData.Process) newData.CreateData.Process = newData.CreateData.Task.Process ?? {};
                    newData.CreateData.Process = { ...newData.CreateData.Process, CustomerSupplierNumber: customer ?? curCustomer.id };
                    if (props.viewSettings.addView === 'CustomerVisitAddView') {
                        newData.CreateData.TaskType = 'Visit';
                    }
                    if (newData.CreateData.Process.ProfilingValues) {
                        newData.CreateData.Process.ProfilingValues = newData.CreateData.Process.ProfilingValues.map(profiling => {
                            return { ...profiling, Index: 0, ProcessIndex: 0 };
                        });
                    }

                    //save Task to specifix Process
                    if (curProcess) newData.CreateData.Process.Index = curProcess.Index;
                    break;
            }

            if (viewData.Data.PersonInChargeID && typeof viewData.Data.PersonInChargeID === 'object') {
                newData.CreateData.Task.PersonInChargeName = viewData.Data.PersonInChargeID.label;
                newData.CreateData.Task.PersonInChargeID = viewData.Data.PersonInChargeID.value;
            }

            //Multiflexcenter saves mutliple Emails with ; - in HTML we need ,
            if (newData.CreateData.EmailAddress) newData.CreateData.EmailAddress = newData.CreateData.EmailAddress.replace(',', ';');

            apiPost('/' + LocalStorage?.getConnectionKey() + props.viewSettings.createUrl, newData)
                .then((data: any) => {
                    if (data.Success && data.Index && newData?.Data?.TravelExpenseData && newData.Data.TravelExpenseData[0].UploadFile) {
                        newData.Data.TravelExpenseData[0].UploadFile?.forEach(file => {
                            var body = { Data: { DocumentType: 'ExpenseReport', DocumentIndex: data.Index, Content: { FileContentBase64: file.data, Filename: file.name } } };
                            apiPost('/' + LocalStorage?.getConnectionKey() + URLS.CreateDocumentAttachment, body).then((data: any) => {
                                if (data.CreateStatus === 1) {
                                    curFormData.reset();
                                    setSaveMessage({ success: true, message: 14233 });
                                    if (props.viewSettings.modalButtons) {
                                        props.viewSettings.modalButtons.forEach(button => {
                                            if (button.action === 'toCreatedData' && (props.viewSettings.viewName === 'TaskAddView' || props.viewSettings.viewName === 'CustomerVisitAddView')) return (button.url = button.url + 'index=' + data.CreatedData.Task.Index);
                                        });
                                    }
                                } else {
                                    setSaveMessage({ success: false, message: window.Dictionary.getTranslation(14234) + ': <br/>' + data.Meta.ErrorMessages[0].Message });
                                }
                                setDataLoaded(true);
                            });
                            //wait(5000);
                        });
                    } else if (data.Success || data.Meta.Success) {
                        if (props.withFilledData && downloadICL) {
                            createDownloadICSFile(
                                'Europe/Vienna',
                                new Date(newData?.CreateData?.Task?.Begin),
                                new Date(newData?.CreateData?.Task?.EndTime),
                                newData?.CreateData?.Process?.Text ?? 'NewTask',
                                window.location.origin + window.location.pathname + '?type=task&index=' + data.CreatedData.Task.Index + '&customer=' + data.CreatedData.Process.CustomerSupplierNumber + '&process=' + data.CreatedData.Process.Index
                            );
                        }
                        if (props.withFilledData && closeOriginalTask) {
                            var updateObj = { Task: { ...filledData }, Process: { ...filledData.Process } };
                            if (!updateObj.Task?.Finished) {
                                updateObj.Task.Finished = 1;
                                loadJsonPut('/' + LocalStorage?.getConnectionKey() + URLS.UpdateTask, { UpdateData: updateObj }).then((data: any) => {});
                            }
                            setForwardingLink(mainTabLink(`/processes/detailview?type=task&index=${data.CreatedData.Task?.Index}&customer=${data.CreatedData.Process.CustomerSupplierNumber}&process=${data.CreatedData.Process.Index}`));
                        }
                        curFormData.reset();
                        setSaveMessage({ success: true, message: 14233 });
                        if (props.viewSettings.modalButtons) {
                            props.viewSettings.modalButtons.forEach(button => {
                                if (button.action === 'toCreatedData' && (props.viewSettings.viewName === 'TaskAddView' || props.viewSettings.viewName === 'CustomerVisitAddView')) return (button.url = button.url + 'index=' + data.CreatedData.Task.Index);
                            });
                        }
                        setDataLoaded(true);
                    } else {
                        setSaveMessage({ success: false, message: window.Dictionary.getTranslation(14234) + ': <br/>' + data.Meta.ErrorMessages[0].Message });
                        setDataLoaded(true);
                    }
                })
                .catch(data => {
                    setSaveMessage({ success: false, message: window.Dictionary.getTranslation(14234) + ': <br/>' + data.Meta.ErrorMessages[0].Message });

                    setDataLoaded(true);
                });
        }
    }

    function wait(ms) {
        var start = new Date().getTime();
        var end = start;
        while (end < start + ms) {
            end = new Date().getTime();
        }
    }

    function changeData(valueObject) {
        setSaveMessage(null);
        if (props.viewSettings.addView === 'TimeRecordingAddView' && ((valueObject.designData.Key === 'Type' && valueObject.newValue.split('-')[1] === '80') || (valueObject.designData.Key === 'Date' && viewData.Data.Type?.split('-')?.[1] === '80'))) {
            const isoLocal = viewData.Data.Date ? viewData.Data.Date?.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
            setValue(viewData.Data, ['WorkingTimeFrom'], isoLocal + 'T00:00:00');
            setValue(viewData.Data, ['WorkingTimeUntil'], isoLocal + 'T00:00:00');
        }
        setValue(viewData.Data, valueObject.designData.Key.split('-'), valueObject.newValue);
        //---------- different conditions ----------------
        if (valueObject.designData.Conditions && valueObject.designData.Conditions[0] && valueObject.designData.Conditions[0].type === 'alternative') {
            setValue(viewData.Data, valueObject.designData.Conditions[0].value.split('-'), '');
            if (valueObject.designData.Conditions[0].value === 'PersonInChargeID' && valueObject.designData.Conditions[0].type === 'alternative') {
                setValue(viewData.Data, valueObject.designData.Conditions[0].value.replace('PersonInChargeID', 'PersonInChargeName').split('-'), '');
            }
            if (valueObject.designData.Conditions[0].value === 'PersonInChargeNumber' && valueObject.designData.Conditions[0].type === 'alternative') {
                setValue(viewData.Data, valueObject.designData.Conditions[0].value.replace('PersonInChargeNumber', 'PersonInChargeName').split('-'), '');
            }
        }
        setViewData({ ...viewData });
    }

    function setValue(data, keys, value) {
        if (keys.length === 1) data[keys[0]] = value;
        else {
            console.log(data[keys[0]], keys.slice(1), value);
            setValue(data[keys[0]], keys.slice(1), value);
        }
    }

    const getSearchResults = e => {
        setSearchResults(null);
        if (timeout) clearTimeout(timeout);
        if (e.target.value.length > 2) {
            if (e.key === 'Enter') loadSearchData(e.target.value);
            else
                timeout = setTimeout(() => {
                    loadSearchData(e.target.value);
                }, 300);
        }
    };

    function loadSearchData(term: string) {
        setSearchResultLoaded(false);
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.Search + '?Term=' + term + '&Type=Customers').then((data: any) => {
            if (data?.Data?.SearchResults) {
                setSearchResults({ data: data.Data.SearchResults });
                setSearchResultLoaded(true);
                if (data?.Data?.SearchResults.length === 0) setSearchResults({ message: 14225 });
            } else {
                setSearchResults({ message: 14225 });
            }
        });
    }

    function fillQrCodeData(data) {
        Object.entries(data).forEach(d => {
            setValue(viewData.Data, d[0].split('-'), d[1]);
        });
        setViewData({ ...viewData });
    }

    function getValue(data, keys) {
        if (!data || keys[0] === 'EmptyElement') {
            return null;
        }
        if (keys.length === 1) {
            return data[keys[0]];
        } else {
            return getValue(data[keys[0]], keys.slice(1));
        }
    }

    function getGenericElement(designD, key, uniqueIndex, idx) {
        const keys = (key as string).split('-');
        if (keys[0] === 'Data') keys.splice(0, 1);
        let value = getValue(viewData.Data,keys);
        if (keys[0] === 'Process' && process) {
            designD.ReadOnly = true;
        }
        if (keys.includes('ProfilingValues')) {
            value = { Profiling: value, Assignment: viewData.Data?.Assignment ?? viewData.Data?.Process?.Assignment, Category: viewData.Data?.Categorie, ProjectStatus: viewData.Data?.ProjectStatusInx };
        }
        
        var customId = curCustomer?.id;
        if (keys.includes('ProjectStatusInx')) {
            customId = viewData.Data?.ProjectStatusSystemInx;
        }

        return (
            <GenericElement
                customData={value}
                designData={{ ...designD, curProcess: curProcess }}
                customId={customId}
                key={uniqueIndex + idx}
                index={uniqueIndex}
                isRecording={recording}
                setRecording={val => setRecording(val)}
                disableMode={false}
                noLabel={false}
                profilingLoaded={val => {
                    setProfilingLoaded(val);
                }}
                onChangeGenericElement={(valueObject: any) => {
                    changeData({ ...valueObject, idx: idx });
                }}
                viewName="addView"
            />
        );
    }

    //#region ical
    function download(filename, fileBody) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(fileBody));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    function convertToICSDate(dateTime) {
        //dateTime.setHours(dateTime.getHours() - 1);
        dateTime = new Date(Date.UTC(dateTime.getUTCFullYear(), dateTime.getUTCMonth(), dateTime.getUTCDate(), dateTime.getUTCHours(), dateTime.getUTCMinutes(), dateTime.getUTCSeconds()));

        const year = dateTime.getUTCFullYear().toString();
        const month = dateTime.getUTCMonth() + 1 < 10 ? '0' + (dateTime.getUTCMonth() + 1).toString() : (dateTime.getUTCMonth() + 1).toString();
        const day = dateTime.getUTCDate() < 10 ? '0' + dateTime.getUTCDate().toString() : dateTime.getUTCDate().toString();
        const hours = dateTime.getUTCHours() < 10 ? '0' + dateTime.getUTCHours().toString() : dateTime.getUTCHours().toString();
        const minutes = dateTime.getUTCMinutes() < 10 ? '0' + dateTime.getUTCMinutes().toString() : dateTime.getUTCMinutes().toString();
        return year + month + day + 'T' + hours + minutes + '00Z';
    }

    function createDownloadICSFile(timezone, startTime, endTime, title, description) {
        const icsBody =
            'BEGIN:VCALENDAR\n' +
            'VERSION:2.0\n' +
            'PRODID:Calendar\n' +
            'CALSCALE:GREGORIAN\n' +
            'METHOD:PUBLISH\n' +
            'BEGIN:VTIMEZONE\n' +
            'END:VTIMEZONE\n' +
            'BEGIN:VEVENT\n' +
            'SUMMARY:' +
            title +
            '\n' +
            'UID:@Default\n' +
            'SEQUENCE:0\n' +
            'STATUS:CONFIRMED\n' +
            'TRANSP:TRANSPARENT\n' +
            'DTSTART:' +
            convertToICSDate(startTime) +
            '\n' +
            'DTEND:' +
            convertToICSDate(endTime) +
            '\n' +
            'DTSTAMP:' +
            convertToICSDate(new Date()) +
            '\n' +
            'DESCRIPTION:' +
            description +
            '\n' +
            'END:VEVENT\n' +
            'END:VCALENDAR\n';
        download(title + '.ics', icsBody);
    }
    //#endregion ical
    return (
        <div className={`mfx-add-view ${props.viewName}`} style={{ paddingTop: props.viewSettings.addView === 'CustomerVisitAddView' ? '1rem' : '' }}>
            {props.children}
            {!saveMessage && props.viewSettings.addLabel && <h2>{window.Dictionary.getTranslation(props.viewSettings.addLabel)}</h2>}
            {!dataLoaded && <Loading />}
            {dataLoaded && !saveMessage && (
                <>
                    {props.viewSettings.needCustomer && !curCustomer && (
                        <>
                            <h3>{window.Dictionary.getTranslation(14179)}</h3>
                            <div className="mfx-search">
                                <input type="text" id="mfx-addsearch-input" placeholder={window.Dictionary.getTranslation(7745)} onKeyUp={e => getSearchResults(e)} />
                                {searchResultLoaded && <i className="icon-search"></i>}
                                {!searchResultLoaded && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            right: '8px',
                                            top: '25%',
                                            transform: 'translateY(-50%)',
                                            width: '16px',
                                            height: '16px',
                                            border: '2px solid #ccc',
                                            borderTop: '2px solid #333',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                        }}
                                    />
                                )}
                            </div>
                            {searchResults && !searchResults.message && (
                                <ul className="mfx-customer-result-list">
                                    {Object.keys(searchResults?.data).map(key => (
                                        <li>
                                            <button
                                                onClick={() =>
                                                    setCustomer({
                                                        id: searchResults?.data[key].Value,
                                                        name: searchResults?.data[key].SearchData.Name1,
                                                        searchdata: searchResults?.data[key].SearchData,
                                                    })
                                                }>
                                                <span>{searchResults?.data[key].Value}</span>
                                                <span>{searchResults?.data[key].SearchData.Name1}</span>
                                                <span>{searchResults?.data[key].SearchData.Street},</span>
                                                <span>{searchResults?.data[key].SearchData.City}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {searchResults && !searchResults.message && <p className="error">{searchResults.message}</p>}

                            {/*!dataLoaded && (
                                <ModalOverlay>
                                    <Loading />
                                </ModalOverlay>
                            )*/}
                        </>
                    )}
                    {qrCode.active && (
                        <>
                            <div className="gray-borderradius-bg" onClick={() => setQrCode({ ...qrCode, active: false })}>
                                <i className="icon-arrow-left"></i>
                            </div>
                            <QrScanner
                                prefix={props.viewSettings.qrPrefix}
                                onSuccessfullScan={data => {
                                    setQrCode({ ...qrCode, qrcodedata: data, active: false });
                                    fillQrCodeData(data);
                                }}
                            />
                        </>
                    )}
                    {((props.viewSettings.needCustomer && curCustomer) || !props.viewSettings.needCustomer) && props.viewSettings.enableqrcode && qrCode.hasVideo && !qrCode.active && (
                        <div className="flex flex-end">
                            <button className="button qr-code-button" style={{ margin: 'initial', marginBottom: '0.7rem' }} onClick={() => setQrCode({ ...qrCode, active: true })}>
                                <i className="icon-qr-code"></i>
                            </button>
                        </div>
                    )}

                    <form id="mfx-add-form" onSubmit={handleSubmitIntermidia}>
                        {!qrCode.active && curCustomer && props.viewSettings.needCustomer && (
                            <>
                                {curProcess && (
                                    <div className="add-form-client gray-borderradius-bg">
                                        <h3 style={{ margin: 0 }}>
                                            {window.Dictionary.getTranslation(1398)}: {curProcess.Number}
                                        </h3>
                                        <div>{curProcess.Subject}</div>
                                    </div>
                                )}
                                {curCustomer.name && !props.viewSettings.fixCustomer && (
                                    <div className="add-form-client gray-borderradius-bg">
                                        <div className="add-form-clientheadline flex">
                                            {!props.viewSettings.fixCustomer && <i className="icon-arrow-left" onClick={() => setCustomer(null)}></i>}
                                            {curCustomer.name && (
                                                <h3>
                                                    {window.Dictionary.getTranslation(14180)}: {/*<span>{curCustomer.name}</span>*/}
                                                </h3>
                                            )}
                                        </div>
                                        <div className="add-form-clientdata">
                                            {curCustomer.searchdata && curCustomer.searchdata.Name1 && <p>{curCustomer.searchdata.Name1}</p>}
                                            {curCustomer.searchdata && curCustomer.searchdata.Number && <p>{curCustomer.searchdata.Number}</p>}
                                            {curCustomer.searchdata && curCustomer.searchdata.PostCode && (
                                                <p>
                                                    {curCustomer.searchdata.PostCode} {curCustomer.searchdata.City}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {curCustomer.name && props.viewSettings.fixCustomer && (
                                    <div className="add-form-client">
                                        <h3>
                                            <span>{curCustomer.name}</span>
                                        </h3>
                                    </div>
                                )}
                            </>
                        )}
                        {!qrCode.active && addForm && ((props.viewSettings.needCustomer && curCustomer) || !props.viewSettings.needCustomer) && (
                            <>
                                <div
                                    className="mfx-elements"
                                    style={{
                                        display: Object.keys(addForm.DesignElements).some(key => key.includes('ProfilingValues')) && !profilingLoaded ? 'none' : 'grid',
                                        overflow: props.viewSettings.noOverflow ? 'unset' : 'auto',
                                        maxHeight: props.viewSettings.noOverflow ? '' : '70vh',
                                        scrollbarGutter: props.viewSettings.noOverflow ? 'unset' : 'stable',
                                        overflowX: 'hidden',
                                        gridTemplateColumns: 'repeat(' + (props.viewName === 'NoteAddView' ? 1 : viewData?.DesignData?.Settings?.Columns ?? window.innerWidth <= 768 ? 1 : 2) + ', 1fr)',
                                    }}>
                                    {
                                        // OLD 17.01.24
                                        addForm.ElementsOrder &&
                                            addForm.ElementsOrder[0].map((key, idx) => {
                                                if (addForm.DesignElements[key]) {
                                                    const designD = addForm.DesignElements[key];
                                                    return getGenericElement(designD, key, idx, idx);
                                                }
                                                return <></>;
                                            })
                                    }
                                    {!addForm.ElementsOrder &&
                                        addForm.DesignElements &&
                                        Object.entries(addForm.DesignElements)
                                            .sort((a: any, b: any) => {
                                                return a[1].Order > b[1].Order ? 1 : -1;
                                            })
                                            .map((key: any, idx) => {
                                                return getGenericElement(key[1], key[1].Key, idx, idx);
                                            })}
                                </div>
                                <div>
                                    {props.withoutProcess && (
                                        <>
                                            <div className="mfx-checkbox-element">
                                                <input type="checkbox" id="checkbox-download-icl" checked={downloadICL} onChange={e => setDownloadICL(e.target.checked)}></input>
                                                <label htmlFor="checkbox-download-icl"> {window.Dictionary.getTranslation(16342)}</label>
                                            </div>
                                            <div className="mfx-checkbox-element">
                                                <input type="checkbox" id="checkbox-close-prev" checked={closeOriginalTask} onChange={e => setCloseOriginalTask(e.target.checked)}></input>
                                                <label htmlFor="checkbox-close-prev"> {window.Dictionary.getTranslation(17270)}</label>
                                            </div>
                                        </>
                                    )}
                                    <button type="submit" id="button-create" className="send-button button center">
                                        {window.Dictionary.getTranslation(4765)}
                                    </button>
                                </div>
                            </>
                        )}
                    </form>
                </>
            )}
            {saveMessage && (
                <SavedModal
                    saveMessage={saveMessage}
                    closeIcon={true}
                    handleClose={() => {
                        if (forwardingLink) window.location.href = forwardingLink;
                        else if (props.onSave) {
                            setSaveMessage(null);
                            props.onSave();
                        } else window.location.reload();
                    }}
                    modalButtons={props.viewSettings.modalButtons}
                />
            )}
            {confirmOpen && (
                <ConfirmPopup
                    stop={() => setConfirmOpen(false)}
                    confirm={() => {
                        setConfirmOpen(false);
                        handleSubmit({ target: pendingData });
                    }}>
                    {window.Dictionary.getTranslation(6430)}
                </ConfirmPopup>
            )}
        </div>
    );
}

export default AddView;

export function AddViewProvider(props: any): JSX.Element {
    return (
        <Provider store={store}>
            <AddView {...props} />
        </Provider>
    );
}

export type RootState = ReturnType<typeof store.getState>;
